export const routing = {
  locales: ['en', 'ar'], // Added Kurdish
  defaultLocale: 'en', // Arabic as default
  localePrefix: 'as-needed', // Only non-default locale shows in URL
};
